module.exports = __webpack_public_path__ + "static/media/poweredby.f405b901.png";